import { defineStore } from "pinia";
import apiClient from "@/core/buildRequest";

export const useSuperLeedForm = defineStore("leedform", {
  state: () => ({
    selectedTiktokAccount: "",
    selectedSnapAccount: "",
    MetaLeedDetails: {
      selectedMeta: null,
      formName: "",
      enableGreeting: true,
      toggleGreeting: true,
      headline: "",
      description: "",
    },
    MetaLeedQuestions: {
      questions: [],
      customQuestions: [
        {
          type: "multiple choice",
          label: "",
          optional: false,
          options: ["Option 1"],
          newOptionInput: false,
          newOptionValue: "",
        },
      ],
      personalFields: [
        { name: "First Name", value: "" },
        { name: "Last Name", value: "" },
        { name: "Email", value: "" },
      ],
    },
    MetaLeedDisclosures: {
      privacyPolicy: {
        link: "",
        linkText: "",
      },
      customDisclosure: {
        enabled: true,
        title: "",
        text: "",
      },
    },
    MetaLeedEnding: {
      leadMessage: {
        headline: "",
        description: "",
      },
      selectedAction: "VIEW_WEBSITE",
      actionData: {
        link: "",
        cta: "Apply now",
      },
    },
    SnapLeedDetails: {
      formName: "",
      formTitle: "",
      description: "",
    },
    SnapLeedQuestions: {
      questions: [],
      customQuestions: [
        {
          type: "multiple choice",
          label: "",
          optional: false,
          options: ["Option 1"],
          newOptionInput: false,
          newOptionValue: "",
        },
      ],
      personalFields: [
        { name: "First Name", value: "" },
        { name: "Last Name", value: "" },
        { name: "Email", value: "" },
      ],
    },
    SnapLeedDisclosures: {
      privacyPolicyUrl: "",
      customDisclosure: {
        enabled: true,
        title: "",
        description: "",
      },
    },
    SnapLeedEnding: {
      enabled: true,
      buttonText: "APPLY_NOW",
      url: "",
    },
  }),

  getters: {},

  actions: {
    setMetaField(key, value) {
      this.MetaLeedDetails[key] = value;
    },

    async sendmeta() {
      const formData = new FormData();

      // 1. Platforms
      formData.append("platforms[0]", "facebook");

      // 2. Basic Details
      formData.append("form_name", this.MetaLeedDetails.formName);
      formData.append("form_title", this.MetaLeedDetails.headline);
      formData.append("greeting_headline", this.MetaLeedDetails.headline);
      formData.append("greeting_content[0]", this.MetaLeedDetails.description);
      // formData.append(
      //   "facebook_page_id",
      //   this.MetaLeedDetails.selectedMeta || ""
      // );

      const accounts = JSON.parse(
        localStorage.getItem("selected_identity_accounts") || "{}"
      );
      const MetaAccountId = accounts.facebook?.id;
      formData.append("facebook_page_id", MetaAccountId);

      // 3. Questions
      let questionIndex = 0;

      // 3.1 Personal Fields
      this.MetaLeedQuestions.personalFields.forEach((field) => {
        const name = field.name.toLowerCase();

        if (name.includes("first")) {
          formData.append(
            `questions[${questionIndex}][question]`,
            "FIRST_NAME"
          );
          formData.append(`questions[${questionIndex}][type]`, "FIRST_NAME");
        } else if (name.includes("last")) {
          formData.append(`questions[${questionIndex}][question]`, "LAST_NAME");
          formData.append(`questions[${questionIndex}][type]`, "LAST_NAME");
        } else if (name.includes("email")) {
          formData.append(`questions[${questionIndex}][question]`, "EMAIL");
          formData.append(`questions[${questionIndex}][type]`, "EMAIL");
        } else if (name.includes("phone") && name.includes("work")) {
          formData.append(
            `questions[${questionIndex}][question]`,
            "WORK_PHONE_NUMBER"
          );
          formData.append(
            `questions[${questionIndex}][type]`,
            "WORK_PHONE_NUMBER"
          );
        } else if (name.includes("phone")) {
          formData.append(`questions[${questionIndex}][question]`, "PHONE");
          formData.append(`questions[${questionIndex}][type]`, "PHONE");
        } else if (name.includes("city")) {
          formData.append(`questions[${questionIndex}][question]`, "CITY");
          formData.append(`questions[${questionIndex}][type]`, "CITY");
        } else if (name.includes("country")) {
          formData.append(`questions[${questionIndex}][question]`, "COUNTRY");
          formData.append(`questions[${questionIndex}][type]`, "COUNTRY");
        } else if (name.includes("state")) {
          formData.append(`questions[${questionIndex}][question]`, "STATE");
          formData.append(`questions[${questionIndex}][type]`, "STATE");
        } else if (name.includes("province")) {
          formData.append(`questions[${questionIndex}][question]`, "PROVINCE");
          formData.append(`questions[${questionIndex}][type]`, "PROVINCE");
        } else if (name.includes("zip")) {
          formData.append(`questions[${questionIndex}][question]`, "ZIP");
          formData.append(`questions[${questionIndex}][type]`, "ZIP");
        } else if (name.includes("post")) {
          formData.append(`questions[${questionIndex}][question]`, "POST_CODE");
          formData.append(`questions[${questionIndex}][type]`, "POST_CODE");
        } else if (name.includes("address")) {
          formData.append(
            `questions[${questionIndex}][question]`,
            "STREET_ADDRESS"
          );
          formData.append(
            `questions[${questionIndex}][type]`,
            "STREET_ADDRESS"
          );
        } else if (name.includes("whatsapp")) {
          formData.append(
            `questions[${questionIndex}][question]`,
            "WHATSAPP_NUMBER"
          );
          formData.append(
            `questions[${questionIndex}][type]`,
            "WHATSAPP_NUMBER"
          );
        } else if (name.includes("dob") || name.includes("birth")) {
          formData.append(
            `questions[${questionIndex}][question]`,
            "BIRTHDAY_DATE"
          );
          formData.append(`questions[${questionIndex}][type]`, "BIRTHDAY_DATE");
        } else if (name.includes("gender")) {
          formData.append(`questions[${questionIndex}][question]`, "GENDER");
          formData.append(`questions[${questionIndex}][type]`, "GENDER");
        } else if (name.includes("marital") || name.includes("marriage")) {
          formData.append(
            `questions[${questionIndex}][question]`,
            "MARITIAL_STATUS"
          );
          formData.append(
            `questions[${questionIndex}][type]`,
            "MARITIAL_STATUS"
          );
        } else if (name.includes("relationship")) {
          formData.append(
            `questions[${questionIndex}][question]`,
            "RELATIONSHIP_STATUS"
          );
          formData.append(
            `questions[${questionIndex}][type]`,
            "RELATIONSHIP_STATUS"
          );
        } else if (name.includes("military")) {
          formData.append(
            `questions[${questionIndex}][question]`,
            "MILITARY_STATUS"
          );
          formData.append(
            `questions[${questionIndex}][type]`,
            "MILITARY_STATUS"
          );
        } else if (name.includes("job")) {
          formData.append(`questions[${questionIndex}][question]`, "JOB_TITLE");
          formData.append(`questions[${questionIndex}][type]`, "JOB_TITLE");
        } else if (name.includes("company")) {
          formData.append(
            `questions[${questionIndex}][question]`,
            "COMPANY_NAME"
          );
          formData.append(`questions[${questionIndex}][type]`, "COMPANY_NAME");
        } else if (name.includes("cpf")) {
          formData.append(`questions[${questionIndex}][question]`, "ID_CPF");
          formData.append(`questions[${questionIndex}][type]`, "ID_CPF");
        } else if (name.includes("dni") && name.includes("argentina")) {
          formData.append(`questions[${questionIndex}][question]`, "ID_AR_DNI");
          formData.append(`questions[${questionIndex}][type]`, "ID_AR_DNI");
        } else if (name.includes("dni") && name.includes("peru")) {
          formData.append(`questions[${questionIndex}][question]`, "ID_PE_DNI");
          formData.append(`questions[${questionIndex}][type]`, "ID_PE_DNI");
        } else if (name.includes("rut")) {
          formData.append(`questions[${questionIndex}][question]`, "ID_CL_RUT");
          formData.append(`questions[${questionIndex}][type]`, "ID_CL_RUT");
        } else if (name.includes("cc")) {
          formData.append(`questions[${questionIndex}][question]`, "ID_CO_CC");
          formData.append(`questions[${questionIndex}][type]`, "ID_CO_CC");
        } else if (name.includes("ci")) {
          formData.append(`questions[${questionIndex}][question]`, "ID_EC_CI");
          formData.append(`questions[${questionIndex}][type]`, "ID_EC_CI");
        } else if (name.includes("rfc")) {
          formData.append(`questions[${questionIndex}][question]`, "ID_MX_RFC");
          formData.append(`questions[${questionIndex}][type]`, "ID_MX_RFC");
        } else {
          formData.append(`questions[${questionIndex}][question]`, field.name);
          formData.append(`questions[${questionIndex}][type]`, "CUSTOM");
        }

        questionIndex++;
      });

      // 3.2 Custom Questions
      this.MetaLeedQuestions.customQuestions.forEach((q) => {
        formData.append(`questions[${questionIndex}][question]`, q.label);
        formData.append(`questions[${questionIndex}][type]`, "CUSTOM");

        if (q.type === "multiple choice") {
          q.options.forEach((choice, i) => {
            formData.append(
              `questions[${questionIndex}][multiple_choice_options][${i}][choice]`,
              choice
            );
          });
        }

        questionIndex++;
      });

      // 4. Disclosures
      if (this.MetaLeedDisclosures.customDisclosure.enabled) {
        formData.append(
          "disclosures_title",
          this.MetaLeedDisclosures.customDisclosure.title
        );
        formData.append(
          "disclosures_description",
          this.MetaLeedDisclosures.customDisclosure.text
        );
      }

      formData.append(
        "privacy_policy_url",
        this.MetaLeedDisclosures.privacyPolicy.link
      );
      formData.append(
        "privacy_policy_text",
        this.MetaLeedDisclosures.privacyPolicy.linkText
      );

      // 5. Thank You / Ending
      formData.append("thank_title", this.MetaLeedEnding.leadMessage.headline);
      formData.append(
        "thank_body",
        this.MetaLeedEnding.leadMessage.description
      );
      formData.append("button_type", this.MetaLeedEnding.selectedAction);
      formData.append("button_text", this.MetaLeedEnding.actionData.cta);
      formData.append("website_url", this.MetaLeedEnding.actionData.link);

      // 6. Send
      try {
        const res = await apiClient.post(
          "/lead-center/create/lead-form",
          formData
        );
        console.log("✅ Lead form created:", res.data);
      } catch (err) {
        console.error("❌ Error submitting lead form:", err);
        throw err;
      }
    },
    async sendsnap() {
      const formData = new FormData();

      // 1. Platform
      formData.append("platforms[0]", "snapchat");

      // 2. Basic form info
      formData.append("form_name", this.SnapLeedDetails.formName);
      formData.append("form_title", this.SnapLeedDetails.formTitle);
      formData.append("form_description", this.SnapLeedDetails.description);
      const accounts = JSON.parse(
        localStorage.getItem("superselected_accounts") || "{}"
      );
      const snapchatAccountId = accounts.snapchat?.id;
      formData.append("snapchat_account_id", snapchatAccountId);

      let questionIndex = 0;

      // 3.1 Personal Fields
      this.SnapLeedQuestions.personalFields.forEach((field) => {
        const name = field.name.toLowerCase();

        if (name.includes("first")) {
          formData.append(
            `questions[${questionIndex}][question]`,
            "FIRST_NAME"
          );
          formData.append(`questions[${questionIndex}][type]`, "FIRST_NAME");
        } else if (name.includes("last")) {
          formData.append(`questions[${questionIndex}][question]`, "LAST_NAME");
          formData.append(`questions[${questionIndex}][type]`, "LAST_NAME");
        } else if (name.includes("phone")) {
          formData.append(`questions[${questionIndex}][question]`, "PHONE");
          formData.append(`questions[${questionIndex}][type]`, "PHONE_NUMBER");
        } else if (name.includes("email")) {
          formData.append(`questions[${questionIndex}][question]`, "EMAIL");
          formData.append(`questions[${questionIndex}][type]`, "EMAIL");
        } else if (name.includes("address")) {
          formData.append(`questions[${questionIndex}][question]`, "ADDRESS");
          formData.append(`questions[${questionIndex}][type]`, "ADDRESS");
        } else if (name.includes("postal") || name.includes("zip")) {
          formData.append(
            `questions[${questionIndex}][question]`,
            "POSTAL_CODE"
          );
          formData.append(`questions[${questionIndex}][type]`, "POSTAL_CODE");
        } else if (name.includes("birth")) {
          formData.append(
            `questions[${questionIndex}][question]`,
            "BIRTHDAY_DATE"
          );
          formData.append(`questions[${questionIndex}][type]`, "BIRTHDAY_DATE");
        } else if (name.includes("job")) {
          formData.append(`questions[${questionIndex}][question]`, "JOB_TITLE");
          formData.append(`questions[${questionIndex}][type]`, "JOB_TITLE");
        } else if (name.includes("company")) {
          formData.append(
            `questions[${questionIndex}][question]`,
            "COMPANY_NAME"
          );
          formData.append(`questions[${questionIndex}][type]`, "COMPANY_NAME");
        }
        // يمكنك إضافة المزيد حسب الحاجة

        questionIndex++;
      });

      // 3.2 Custom Questions
      this.SnapLeedQuestions.customQuestions.forEach((q) => {
        formData.append(`questions[${questionIndex}][type]`, "CUSTOM");
        formData.append(
          `questions[${questionIndex}][question]`,
          q.label || "Custom Question"
        );

        // حدد نوع الحقل حسب نوع السؤال
        let snapFieldType = "TEXT";
        if (q.type?.toLowerCase() === "multiple choice") {
          snapFieldType = "MULTIPLE_CHOICE_MULTI_SELECTION";
        }

        // Snapchat requires this structure
        formData.append(
          `questions[${questionIndex}][custom_form_field_properties][type]`,
          snapFieldType
        );

        formData.append(
          `questions[${questionIndex}][custom_form_field_properties][description]`,
          q.label || "Custom Question"
        );

        // Multiple choice options
        if (snapFieldType === "MULTIPLE_CHOICE_MULTI_SELECTION") {
          q.options?.forEach((choice, i) => {
            formData.append(
              `questions[${questionIndex}][multiple_choice_options][${i}][choice]`,
              choice
            );
          });
        }

        questionIndex++;
      });

      // 4. Disclosures
      if (this.SnapLeedDisclosures.customDisclosure.enabled) {
        formData.append(
          "disclosures_title",
          this.SnapLeedDisclosures.customDisclosure.title
        );
        formData.append(
          "disclosures_description",
          this.SnapLeedDisclosures.customDisclosure.description
        );
      }

      const policyUrl = this.SnapLeedDisclosures.privacyPolicyUrl.trim();
      if (!/^https?:\/\//i.test(policyUrl)) {
        throw new Error(
          "❌ Privacy Policy URL must start with http:// or https://"
        );
      }
      formData.append("privacy_policy_url", policyUrl);

      // 5. Thank You / Ending (CTA)
      formData.append("call_to_action", this.SnapLeedEnding.buttonText);
      formData.append("redirect_url", this.SnapLeedEnding.url);

      // 6. Send
      try {
        const res = await apiClient.post(
          "/lead-center/create/lead-form",
          formData
        );
        console.log("✅ Lead form created:", res.data);
      } catch (err) {
        console.error("❌ Error submitting lead form:", err);
        throw err;
      }
    },
  },
});
